// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".walletMethod[data-v-12c81398]{text-align:center}.button-add-account[data-v-12c81398]{height:.35rem!important;padding:0 .3rem;margin:auto}", ""]);
// Exports
module.exports = exports;
